import { isArrayNotEmpty } from '../../../utils'

import { ConnectwareError, ConnectwareErrorType } from '../../../domain'

import { Usecase } from '..'

type EnvConfigurationErrorExtras = Readonly<{ path: readonly string[], env: string, value: string }>

export class EnvConfigurationError extends ConnectwareError<ConnectwareErrorType.CONFIGURATION_ERROR, EnvConfigurationErrorExtras> {
    static override is (e: unknown): e is EnvConfigurationError {
        return e instanceof EnvConfigurationError
    }

    constructor (path: EnvConfigurationErrorExtras['path'], env: EnvConfigurationErrorExtras['env'], value: EnvConfigurationErrorExtras['value']) {
        super(ConnectwareErrorType.CONFIGURATION_ERROR, 'Could not override configuration because it was found to be invalid', {
            path,
            env,
            value,
        })
    }
}

export class DebugApplicationUsecase extends Usecase {
    handleConfigurationErrors (errors: readonly ConnectwareError[]): void {
        if (!isArrayNotEmpty(errors)) {
            return
        }

        this.logger.warn('There are misconfigured Admin UI customizations that should be looked into')

        for (const error of errors) {
            if (EnvConfigurationError.is(error)) {
                /** User error */
                this.logger.warn(`${error.extras.env} can NOT be set to '${error.extras.value}'`)
            } else {
                /** Unexpected configuration error, means a development bug */
                this.logger.error(error)
            }
        }
    }

    activate (): void {
        if (this.browserService.isInspecting()) {
            this.logger.info('Application is in inspection mode', this)
        }
    }
}
